<template>
	<div class="">
		<v-header></v-header>
		<div class="container">
			<!-- 单选题 -->
			<div class="action1-left" v-if="tixing == 1">
				<div class="toubu">
					<button type="button" @click="fanhui">返回</button>
					<div class="jz">
						<span>性格测评</span>
					</div>
				</div>
				<div class="timu">
					<span class="danxuan" >单选题</span>
					<div class="timuo" v-for="(item,index) in  list" v-if="index == showindex">
						<span class="span2">{{index+1}}.</span>
						<p class="span3" v-if="item.info.length>2">{{item.info}}</p>
            <p class="span3" v-else>根据内容选择符合自己的选项</p>
					</div>
				</div>
				<div class="xz"  v-for="(item,index) in  list" v-if="index == showindex">
					<div  class="duoxuanti1"  :class="{'duoxuanti2':item.flag == item.answeraType}"
          @click="danxuanzhe(index,item.answeraType)">
						<img src="../../assets/img/a1.png" v-if="item.flag !== item.answeraType">
						<img src="../../assets/img/a2.png" v-else>
						<span >{{item.answera}}</span>
					</div>
          <div  class="duoxuanti1" :class="{'duoxuanti2':item.flag == item.answerbType}"
          @click="danxuanzhe(index,item.answerbType)">
          	<img src="../../assets/img/b1.png" v-if="item.flag !== item.answerbType">
          	<img src="../../assets/img/b2.png" v-else>
          	<span >{{item.answerb}}</span>
          </div>
				</div>
				<div class="next">
					<button type="button" @click="xiayiti()" v-if="count != list.length">下一题</button>
          <button type="button" @click="open()" v-else>提交测评</button>
				</div>
			</div>
			<div class="action1-right">
				<div class="jishi">
					<span class="sdjh">剩余时间：</span>
					<span class="red">{{ `${min} : ${sec}` }}</span>
					<!-- <span class="red">{{hours}}:{{minutes}}:{{second}}</span> -->
          <div class="btn">
          	<button type="button" @click="open">提交测评</button>
          </div>
				</div>
				<!-- <div class="ceping">
					<div class="ceping1">
						<div class="ceping-zuo">
							<span class="hui">学生姓名：</span><span class="hei">{{userInfo.userName}}</span>
						</div>
						<div class="ceping-you">
							<span class="hui">所在省份：</span><span class="hei">河北省</span>
						</div>
					</div>

				</div> -->
				<div class="zw">
					<button v-for="(item,index) in  list" type="button" :class="{'yselect':item.flag!=false, 'yu':index == showindex}"
           @click="selectshow(index)">{{index+1}}</button>
				</div>


			</div>

		</div>
		<item7></item7>
	</div>
</template>

<script>
	import vHeader from '../../components/vHeader.vue'
	import item7 from '../../components/item7.vue'
  import {getYear} from '../../libs/tools.js'
	export default {
		components: {
			vHeader,
			item7,
		},
		data() {
			return {
				isshow1: true,
				time: '',
				min: 59,
				sec: 59,
        showindex:0,
        count:0,
        type:3,
        userInfo:this.$utils.getlocalStorage("userInfo"),
				tixing:1,
				radio:0,
				checked1: false,
				checked2: false,
				checked3: false,
				checked4: false,
        list:[],
			}
		},
		methods: {


			// 单选题
			danxuanzhe(index,type){
        if(this.list[index].flag ==false){
          this.count++;
        }
        console.log(this.count)
				this.list[index].flag = type
        this.xiayiti();
			},
			// 多选
      selectshow(index){
        this.showindex = index
      },
			// 下一题
			xiayiti(){
				let _this = this;
        if(this.showindex <this.list.length-1 ){
					this.showindex = this.showindex + 1
				} else{
          if(this.count != this.list.length){
              for(let i in this.list){
                if(this.list[i].flag ==false){
                  this.showindex = parseInt(i);
                  this.selectshow(this.showindex)
                  return false;
                }
              }
          } else {

          }
        }
			},
			// 返回
			fanhui(){
				if(this.tixing > 1){
					this.tixing = this.tixing - 1
				}
			},
			begin() {
				// 点击按钮后开始计算指定长度的时间
				this.time = (Date.parse(new Date()) + ((20 * 60)) * 1000);
				// 开始执行倒计时
				this.countdown();
				// 更换按钮，根据情况选择v-if或v-show
				this.isshow1 = false;

				this.$message({
					type: 'success',
					message: '开始答题'
				});
			},
			countdown() {
				const end = this.time; // 定义结束时间
				const now = Date.parse(new Date()); // 获取本地时间
				const msec = end - now; // 定义总共所需的时间
				// 将时间戳进行格式化
				let min = parseInt(msec / 1000 / 60 % 60);
				let sec = parseInt(msec / 1000 % 60);
				// 倒计时结束时的操作
				const that = this;
				if (this.min == 0 && this.sec == 0) {
					console.log('时间已经结束，答题完毕');
					this.min = 20;
					this.sec = 0;
				} else {
					// 如时间未归零则继续在一秒后执行
					this.min = min > 9 ? min : '0' + min;
					this.sec = sec > 9 ? sec : '0' + sec;
					setTimeout(that.countdown, 1000)
				}
			},
			// 交卷
			open() {
        console.log(this.list)
        let _this = this;
        let sum = {}
        if(this.type == 1){
          sum = [
            {name:"E",value:0,cname: '外倾(E)'},
            {name:"I",value:0,cname: '内倾(I)'},
            {name:"S",value:0,cname: '实感(S)'},
            {name:"N",value:0,cname: '直觉(N)'},
            {name:"T",value:0,cname: '思考(T)'},
            {name:"F",value:0,cname: '情感(F)'},
            {name:"J",value:0,cname: '判断(J)'},
            {name:"P",value:0,cname: '认知(P)'}
          ]
        } else if(this.type == 3){
          sum = [
            {name:"C",value:0,cname: '常规(C)'},
            {name:"R",value:0,cname: '现实(R)'},
            {name:"I",value:0,cname: '研究(I)'},
            {name:"E",value:0,cname: '管理(E)'},
            {name:"S",value:0,cname: '社会(S)'},
            {name:"A",value:0,cname: '艺术(A)'}
          ]
        }
        for(let i in this.list){
          if(this.list[i].flag!=null&&!this.list[i].flag){
            this.showindex = parseInt(i);
            this.selectshow(this.showindex)
            this.$message({
              type: 'warning',
              message: '还有未选择的题目'
            });
            return false;
          } else {
            if(this.type == 1){
              switch(this.list[i].flag){
                case 'E': sum[0].value++; break;
                case 'S': sum[2].value++; break;
                case 'T': sum[4].value++; break;
                case 'J': sum[6].value++; break;

                case 'I': sum[1].value++; break;
                case 'N': sum[3].value++; break;
                case 'F': sum[5].value++; break;
                case 'P': sum[7].value++; break;
              }
            } else if(this.type == 3){
              switch(this.list[i].flag){
                case 'C': sum[0].value++; break;
                case 'R': sum[1].value++; break;
                case 'I': sum[2].value++; break;
                case 'E': sum[3].value++; break;
                case 'S': sum[4].value++; break;
                case 'A': sum[5].value++; break;
              }
            }

          }
        }
        let result = {}
        if(this.type ==1){
          let sum1  = []
          sum1.push(sum[0])
          sum1.push(sum[2])
          sum1.push(sum[4])
          sum1.push(sum[6])
          let sum2  = []
          sum2.push(sum[1])
          sum2.push(sum[3])
          sum2.push(sum[5])
          sum2.push(sum[7])
          sum1.sort(function(a,b){return b.value-a.value})
          let value1 = sum1.slice(0,2)
          sum2.sort(function(a,b){return b.value-a.value})
          let value2 = sum2.slice(0,2)
          result = {
            name:value1[0].name+value1[1].name+value2[0].name+value2[1].name,
            count:sum,
            type:this.type
          }
        } else if(this.type ==3||this.type ==4){
          sum.sort(function(a,b){return b.value-a.value})
          let value1 = sum.slice(0,3)
          result = {
            name:value1[0].name+value1[1].name+value1[2].name,
            count:sum,
            type:this.type
          }
        }
        result.time= getYear(new Date(),'year')

        this.$req.insert("tcphistory", {
           hsType: this.type,
           hsInfo: JSON.stringify(result.count),
           hsName: result.name,
           spare1:this.userInfo.userId,
           spare2:this.userInfo.userName
        }).then(function(resp) {
          if(resp.status == '0'){
            _this.$utils.setlocalStorage('cpresult',result);
            _this.$router.push('/grzx_xinggeceping_result');
          }
        })
			},
      getdata(){
        let _this = this;
        this.$req.queryAllByLimit('topic', {
          pageNum:10,
          pageSize:0,
          queryObj:{
          type:_this.type}}).then(function(response) {
          _this.list = response.data
        })
      }
		},
		mounted() {
			this.begin()
		},
    created() {
      console.log(0)
      this.getdata()
    },
	}
</script>

<style scoped>
	.timuo{
		display: flex;
	}
	.el-checkbox__inner::after {
		background-color: #E63233 !important;
	}
	.el-checkbox.is-bordered+.el-checkbox.is-bordered{
		margin-left: 0;
	}
	.el-checkbox.is-bordered.is-checked{

	}

	.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inne {
		border: 1px solid #E63233;
		background: white;
	}

	.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #E63233;
	}

	.el-checkbox__label {
		font-size: 18px;
	}

	.el-checkbox {
		line-height: 30px;
		display: block;
	}


	/* 多选 */
	.el-checkbox-button .el-checkbox-button__inner{
		border-left: 1!important;
	}
	.miansd{
		display: flex;
		flex-direction: column;
	}
	.duoxuanti1{
		padding: 5px;
		margin-top: 5px;
		background: rgba(249, 249, 249, 1);
		opacity: 1;
		border-radius: 5px;
		display: flex;align-items: center;cursor: pointer;
	}
	.duoxuanti1 span{
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 800;
		color: #666666;
	}
	.duoxuanti2{
		padding: 5px;
		margin-top: 5px;
		background: rgba(255, 237, 235,1);
		opacity: 1;
		border-radius: 5px;
		display: flex;align-items: center;cursor: pointer;
	}
	.duoxuanti2 span{
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 800;
		color: #F53824;
	}
	.panduanti1{
		padding: 5px;
		margin-top: 5px;
		background: rgba(249, 249, 249, 1);
		opacity: 1;
		border-radius: 5px;
		display: flex;align-items: center;cursor: pointer;
	}
	.panduanti1 span{
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 800;
		color: #666666;
	}
	.panduanti2{
		padding: 5px;
		margin-top: 5px;
		background: rgba(255, 237, 235,1);
		opacity: 1;
		border-radius: 5px;
		display: flex;align-items: center;cursor: pointer;
	}
	.panduanti2 span{
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 800;
		color: #F53824;
	}
	.jishi {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.sdjh{
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #F53824;
	}

	.ceping {
		width: 300px;
		height: 20px;
		opacity: 1;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;justify-content: center;
		margin-bottom: 10px;
		/* border: 1px solid #f5efef; */
		padding: 0 10px;
		box-sizing: border-box;
	}

	.red {
		justify-content: center;
		font-size: 28px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #F53824;
	}

	.ceping1 {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 5px;
	}

	.hei {
		font-size: 16px;
		color: #333333;
		font-family: PingFangSC;
		font-weight: bold;
	}

	.hui {
		font-size: 16px;
		color: #666666;
	}

	.action1-right {
		width: 450px;
		height: 616px;
		background: rgba(255, 255, 255, 0.39);
		opacity: 1;
		border-radius: 5px;
		margin-left: 10px;
		box-shadow: 0 0 5px #EEE9E9;
    margin-bottom: 20px;
    border: #e5e5e5 solid 2px;
    border-radius: 15px;
    margin-top: 20px;
	}

	.action1-left {
		flex: 1;
		padding: 30px;
		box-sizing: border-box;
		box-shadow: 0 0 5px #EEE9E9;
    margin-bottom: 20px;
    border: #e5e5e5 solid 2px;
    border-radius: 15px;
    margin-top: 20px;
	}

	.ceping p {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 22px;
		color: #29A7E1;
	}

	.btn {
		text-align: center;
	}

	.btn button {
		border: none;
		width: 120px;
		height: 36px;
		background: linear-gradient(131deg, #F53824 0%, #FE9603 100%);
		opacity: 1;
		border-radius: 43px;
		font-size: 16px;
		font-weight: 500;
		color: #FFFFFF;
		opacity: 1;
    margin-left: 30px;
	}

	.zw button {
		background: white;
		border-radius: 4px;
		color: #aba3a3;
		border: 1px solid #aba3a3;
		margin: 4px;
    padding-left: 2px;
    padding-right: 2px;
    width: 30px;
	}
  .zw .yu {
    color: #E63233;
    border: 1px solid #E63233;
  }
  .zw button:hover{
    color: #E63233;
    border: 1px solid #E63233;
  }
  .zw .yselect {
  	background: #E63233;
  	border-radius: 4px;
  	color: white;
  	border: 1px solid #E63233;
  	margin: 4px;
    padding-left: 2px;
    padding-right: 2px;
  }

	.zw {
		justify-content: flex-start;
    flex-direction: row;
		display: flex;
    flex-wrap: wrap;
    width: 400px;
    margin-left: 40px;
	}

	.container {
		display: flex;
		width: 1280px;
    margin-top: 70px;
	}

	.jz {
		margin: 0 auto;
	}

	.next button {
		justify-content: center;
		border: none;
		display: block;
		width: 140px;
		height: 42px;
		background: linear-gradient(92deg, #F53824 0%, #FE9603 100%);
		opacity: 1;
		border-radius: 5px;
		font-size: 16px;
		font-weight: 500;
		color: #FFFFFF;
		opacity: 1;
	}

	.timu .span2 {
		color: #F53824;
		font-size: 22px;
		margin: 0 5px 0 15px;
		flex-shrink: 0;
	}

	.timu .span3 {
		font-size: 18px;
		font-weight: 800;
		color: #333333;
    line-height: 32px;
		opacity: 1;
		flex: 1;
	}

	.timu .span1 {
		flex-shrink: 0;
		font-size: 17px;
		font-weight: 500;
		color: #FE9603;
		opacity: 1;
		width: 64px;
		height: 28px;
		background: rgb(255, 235, 207);
		opacity: 1;
		border-radius: 5px;
		display: flex;align-items: center;justify-content: center;
	}
	.timu .danxuan {
		flex-shrink: 0;
		opacity: 1;
		width: 64px;
		height: 28px;
		background: rgba(255, 217, 213, 0.39);
		opacity: 1;
		border-radius: 5px;
		display: flex;align-items: center;justify-content: center;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 37px;
		color: #F53824;
	}
	.timu .duoxuan {
		flex-shrink: 0;
		opacity: 1;
		width: 64px;
		height: 28px;
		background: rgba(213, 242, 255, 0.39);
		opacity: 1;
		border-radius: 5px;
		display: flex;align-items: center;justify-content: center;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 37px;
		color: #29A7E1;
	}

	.timu {
		display: flex;
		margin: 10px 0;
	}

	.toubu span {
		font-size: 24px;
		font-weight: 500;
		color: #29A7E1;
		opacity: 1;
	}

	.toubu button {
		position: absolute;
		top: 0;
		border: none;
		font-size: 14px;
		font-weight: 500;
		color: #FFFFFF;
		opacity: 1;
		width: 90px;
		height: 30px;
		background: rgb(245, 56, 36);
		opacity: 1;
		border-radius: 26px;
	}

	.toubu {
		position: relative;
		display: flex;
	}

	.xz {
		display: block;
	}

	.el-radio {
		display: block;
		line-height: 50px;
	}

	.next {
		display: flex;
		justify-content: center;
		margin-top: 40px
	}

	@media (max-width:750px) {
		.timu .danxuan{margin-left: 15px;}
		.timuo{margin-top: 15px;}
		.xz{width: 80%;margin-left: 30px;}

		.container {
			display: block;
			width: auto;
		}

		.timu {
			display: block;
			line-height: 33px;
		}

		.next {
			justify-content: center;
			display: flex;
			margin: 20px 0;

		}

		.action1-left {
			padding: 10px;
			width: 100%;
		}

		.action1-right {
			padding: 23px;
			width: 100%;
			margin-left: 0;
			margin-top: 20px;
			display: flex;align-items: center;flex-direction: column;
		}

		.jishi {
			display: flex;
			justify-content: center;
		}

		.timu .span1 {
			padding: 0;
			font-size: 15px;
		}

		.timu .span2 {
			font-size: 18px;
			font-weight: 500;
		}

		.timu .span3 {
			font-size: 18px;
			font-weight: 500;
			color: #333333;
			opacity: 1;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/mine/h_startcheping.vue